module.exports = __webpack_public_path__ + "media/images/athletes/2900-f9edb9b9c440ebc60efbe48d6c21ed88.png";